import React, { useState, useEffect } from 'react';
import {
    Container,
    Paper,
    Typography,
    Box,
    Alert,
    Grid,
} from '@mui/material';
import { netflixAccountApi } from '../../services/api';
import { NetflixAccount } from '../../types';
import Navigation from '../common/Navigation';
import NetflixAccountCard from '../main/NetflixAccountCard';

interface UserDashboardProps {
    onLogout: () => void;
}

const UserDashboard: React.FC<UserDashboardProps> = ({ onLogout }) => {
    const [accounts, setAccounts] = useState<NetflixAccount[]>([]);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [currentUser, setCurrentUser] = useState<any>(null);

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            setCurrentUser(JSON.parse(storedUser));
            fetchUserAccounts(JSON.parse(storedUser).id);
        }
    }, []);

    const fetchUserAccounts = async (userId: number) => {
        try {
            setLoading(true);
            const data = await netflixAccountApi.getUserAccounts(userId);
            setAccounts(data);
        } catch (error) {
            setError('Failed to fetch Netflix accounts');
        } finally {
            setLoading(false);
        }
    };

    if (!currentUser) {
        return null;
    }

    return (
        <>
            <Navigation user={currentUser} onLogout={onLogout} />
            <Container>
                <Paper sx={{ width: '100%', mt: 3, p: 3 }}>
                    <Typography variant="h5" gutterBottom color="primary">
                        Your Netflix Accounts
                    </Typography>
                    
                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}

                    {loading ? (
                        <Typography>Loading...</Typography>
                    ) : accounts.length === 0 ? (
                        <Alert severity="info" sx={{ mt: 2 }}>
                            No Netflix accounts assigned to you yet.
                        </Alert>
                    ) : (
                        <Grid container spacing={2} sx={{ mt: 1 }}>
                            {accounts.map((account) => (
                                <Grid item xs={12} key={account.id}>
                                    <NetflixAccountCard account={account} />
                                </Grid>
                            ))}
                        </Grid>
                    )}
                </Paper>
            </Container>
        </>
    );
};

export default UserDashboard; 